import { asNumber } from "@cervval.js/common/src/tools/number.tools";
import { FilterOptionsParams } from "@cervval.js/common/src/tools/string.tools";
import { RenderCacheData } from "@cervval.js/common/src/ui/renderCacheData.types";
import { anyReallyAny } from "@cervval.js/common/tools";
import { filterComparatorStandard } from "./filterExpression";
import { CompareOperators } from "./filterExpression.definition";
import { assertIsNever } from "@cervval.js/common/src/tools/object.tools";

/** Regex to detect [(+,-)number(10 power a number)] */
const REGEX_PARSE_FILTER = /^\s*([-+]*[\d.,]+[eE]*[-+]?[\d.,]*)/;


/** return true if a number value match the numerical compare value by the operator */
export function compareNumberValue(value1: number, operator: CompareOperators, value2: number): boolean {
    switch (operator) {
        case "=":
            return Math.abs(value1 - value2) < Number.EPSILON;
        case "<>":
            return !(Math.abs(value1 - value2) < Number.EPSILON);
        case "<":
            return value1 < value2;
        case "<=":
            return value1 <= value2;
        case ">":
            return value1 > value2;
        case ">=":
            return value1 >= value2;
        default:
            assertIsNever(operator);
    }
    return false;
}

/** 
 * A converter to convert anything into a number.
 * @param itemValue The anything to convert.
 * @returns A number if successful, undefined otherwise.
 */
function _convertToNumber(itemValue: anyReallyAny): (number | undefined) {
    return typeof itemValue === "number" ? itemValue : asNumber(itemValue.replace(",", ".")) ?? undefined;
}

/** 
 * A parser to parse a string as a number.
 * @param str The string to parse.
 * @returns A number if successful, null otherwise.
 */
function _filterParser(str: string): (number | null) {
    return str.match(REGEX_PARSE_FILTER) ? asNumber(str.replace(",", ".")) : null;
}

/** compare a FilterOptionsParams for number, if filter is invalid return true to display all rows  */
export function filterComparatorNumber(p: FilterOptionsParams<anyReallyAny>, renderCacheData?: RenderCacheData): boolean {
    return filterComparatorStandard(p, _filterParser, _convertToNumber, compareNumberValue, renderCacheData);
}